import { BpAnchor } from '../../../../shared/components/text/anchor/BpAnchor'
import React from 'react'

interface PageCellProps {
  page: string
}

export const PageCell = ({ page }: PageCellProps) => {
  return (
    <BpAnchor
      className='block w-96 overflow-hidden text-ellipsis whitespace-nowrap leading-5'
      href={page}
      target='_blank'
    >
      {page.split('?')[0]}
    </BpAnchor>
  )
}
